export namespace FlowStage {
  export const FlowKey = {
    PENSIONS: "PENSIONS",
    INVESTMENTS: "INVESTMENTS",
  } as const

  export type FlowKey = keyof typeof FlowStage.FlowKey

  export const StageKey = {
    KYC_ONE: "KYC_ONE",
    AWAITING_MISLAKA: "AWAITING_MISLAKA",
    COMPLETED_MISLAKA: "COMPLETED_MISLAKA",
    PORTFOLIO: "PORTFOLIO",
    VALUE_PROPOSITION: "VALUE_PROPOSITION",
    RECOMMENDATIONS: "RECOMMENDATIONS",
    AWAITING_FORMALLY: "AWAITING_FORMALLY",
    COMPLETED: "COMPLETED",
  } as const

  export type StageKey = keyof typeof FlowStage.StageKey
}
